import api from "@api";
import { paths } from "@api/schema";
import {
  IBasket,
  IUnsavedBasketItem,
} from "@modules/Purchasing/services/baskets";
import {
  IPaymentMethod,
  IPaymentMethodProvider,
  ISetupConfig,
  IUserPaymentMethod,
  IUserPaymentMethods,
  PaymentMethodProviderCombination,
  PaymentMethodType,
} from "../types";

export type {
  IPaymentMethod,
  IPaymentMethodProvider,
  PaymentMethodType,
  IUserPaymentMethod,
} from "../types";

export const API_PATH = "user_payment_methods";

export type SetupPaymentMethodProps<T extends PaymentMethodType> =
  PaymentMethodProviderCombination<T>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const setupPaymentMethod = async <T extends PaymentMethodType>(
  body: SetupPaymentMethodProps<T>
) => {
  const {
    data: { config },
  } = await api.post<SetupPaymentMethodProps<T>, ISetupConfig>(
    `${API_PATH}/setup`,
    body
  );
  return config;
  /*   return {
    clientSecret:
      "seti_1LIVx9JU51bfYtbQaOKYn1kC_secret_M0X1E6orRxaIcnStDzNjW7JteM6azmw",
  }; */
};

export const getUserPaymentMethods = async () => {
  return await api.get<undefined, IUserPaymentMethods>(API_PATH);
};

export interface CreateOrUpdatePaymentMethodProps<T extends IPaymentMethod> {
  provider: IPaymentMethodProvider<T>;
  method: T;
  preferred: boolean;
}

export const createOrUpdatePaymentMethod = async <T extends IPaymentMethod>(
  body: CreateOrUpdatePaymentMethodProps<T>
) => {
  return await api.post<
    CreateOrUpdatePaymentMethodProps<T>,
    IUserPaymentMethod
  >(API_PATH, body);
};

type ILoadBasketItemRequestBody =
  paths["/baskets/{id}/available_payment_methods"]["post"]["requestBody"]["content"]["application/json"];

export interface IAvailablePaymentMethod {
  enabled: boolean;
  allowed: boolean;
  name: PaymentMethodType;
}

export const loadBasketPaymentMethodNames = async ({
  id,
  items,
}: {
  id: IBasket["id"];
  items?: IUnsavedBasketItem[];
}): Promise<IAvailablePaymentMethod[]> => {
  try {
    const { data } = await api.post<
      ILoadBasketItemRequestBody,
      IAvailablePaymentMethod[]
    >(`baskets/${id}/available_payment_methods`, { items });

    return data;
  } catch (error) {
    throw error;
  }
};
